<template>
  <TableList
    ref="TableList"
    v-loading="listLoading"
    :dataList="list"
    :columnAllData="columnAllData"
    :showSelection="false"
    :canRefresh="false"
    :canChangeColumn="false"
    :isShowPagination="false"
    :canCommand="false"
    :handleDefaultWidth="240"
    :maxHight="224"
  >
  </TableList>
</template>

<script lang='ts'>
import { defineComponent, reactive, toRefs, onMounted, ref, watch } from 'vue'
import { businessEngineersList } from '@/apis/Business'

import { CostModel } from '@/model/Index'

import TableList from '@/components/common/TableList.vue'
// import { TableName, permissionName } from '@/utils/enum'
import { TableField } from './FieldTable'

import { useI18n } from 'vue-i18n'
export default defineComponent({
  name: 'Engineerinfo',
  components: {
    TableList
  },
  props: {
    id: { type: Number, required: true, default: 0 }
  },
  setup(props) {
    const { t } = useI18n()
    const TableList = ref(null)

    const dataMap = reactive({
      // TableName: TableName.TABLE_OUTSOURCE_ENGINEER_INFO,
      // permissionName: permissionName.OUTSOURCE_ENGINEER_INFO,
      columnAllData: TableField,
      activeId: 0,
      list: [],
      listLoading: false,

      getList() {
        if (!props.id) {
          dataMap.list = []
          return
        }
        dataMap.listLoading = true
        businessEngineersList(props.id).then((res: any) => {
          dataMap.list = res || []
          dataMap.listLoading = false
        }).catch(() => {
          dataMap.listLoading = false
        })
      }
    })

    watch(() => props.id, () => {
      dataMap.getList()
    })

    onMounted(async() => {
      dataMap.getList()
    })
    return { TableList, t, ...toRefs(dataMap) }
  }
})
</script>
